<template>
  <div class="s-layout">
    <div class="s-container">
      <div class="content">
        <h1 class="text-center mt-4 mb-3">選擇院所</h1>
        <b-overlay :show="isLoadingInstitutions || isUpdatingSelectedInstitution">
          <div class="institution-list">
            <button
              v-for="institution in availableInstitutions"
              :key="institution.display_name"
              class="institution-list__select-institution"
              @click="updateSelectedInstitution(institution)"
            >
              {{ institution.display_name }}
            </button>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import cresclabMenuApi from "@/apis/liff/v2/cresclab-menu"

export default {
  data() {
    return {
      availableInstitutions: [],
      isLoadingInstitutions: false,
      isUpdatingSelectedInstitution: false,
    }
  },
  computed: {
    //
  },
  async mounted() {
    this.isLoadingInstitutions = true
    this.availableInstitutions = _.get(await cresclabMenuApi.listAvailableInstitutions(), "data.data", [])
    this.isLoadingInstitutions = false
  },
  methods: {
    async updateSelectedInstitution(institution) {
      this.isUpdatingSelectedInstitution = true
      try {
        await cresclabMenuApi.updateSelectedInstitution(institution.tag_name)
        this.$swal("院所已更新", "", "success")
      } catch (error) {
        this.$swal("院所更新失敗", "", "error")
      }
      this.isUpdatingSelectedInstitution = false
    }
  },
}
</script>

<style lang="scss" scoped>
.institution-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  &__select-institution {
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    background-color: #e5e5ea;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      background-color: #f0f0f0;
    }
  }
}

</style>
